import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import { isDesign } from "../../../service/oneClickIs"
import type EstimateValues from "../../../types/params"

const isValidMetalMaskDtl = (values: EstimateValues, metalMaskDtl?: string) => {
  switch (metalMaskDtl) {
    case ESTIMATE_CONSTANT["メタルマスクの製造・支給選択"][
      "マスク用ガーバーデータが無く、基板ガーバーデータ一式から製造する"
    ].value:
      return !isDesign(values)

    case ESTIMATE_CONSTANT["メタルマスクの製造・支給選択"].マスク用ガーバーデータから製造する.value:
    case ESTIMATE_CONSTANT["メタルマスクの製造・支給選択"].お客様より支給あり.value:
    // 初期値が未選択状態なためtrueを返す
    default:
      return true
  }
}

export default isValidMetalMaskDtl
